import React, { useEffect, useState } from "react"
import { Box, Button, Checkbox, FormControlLabel, TextField, Typography, FormControl } from "@mui/material"
import Grid from "@mui/material/Grid2"
import DownloadIcon from "@mui/icons-material/Download"
import CustomTable from "../../components/table/Table"
import { useDispatch, useSelector } from "react-redux"
import { createRole, deleteRole, fetchRoles, updateRole } from "../../redux/Slice/roleSlice"
import { setLoading } from "../../redux/Slice/loaderSlice"
import { side_menus } from "../../constants/SideMenus";
import { fetchEmployees, updateEmployee } from "../../redux/Slice/employeeSlice";
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import { Link, Navigate, useNavigate } from "react-router-dom";
import * as XLSX from 'xlsx';
import { clearMessage } from "../../redux/Slice/message"
import { toast } from "sonner"


const columns = [
  { id: 'sno', label: 'S.No', minWidth: 50, align:'start' },
  { id: 'user_id', label: 'IDs', minWidth: 150, align:'start' },
  { id: 'name', label: 'Role Name', minWidth: 150, align:'start' },
  { id: 'email', label: 'Email', minWidth: 150, align:'start' },
  { id: 'role', label: 'Role', minWidth: 150, align:'start' },
  { id: 'status', label: 'Status', minWidth: 50, align:'start' },
  { id: 'action', label: 'Action', minWidth: 100, align:'center', actionType: [{edit: true, view: true}] },
];

const EmployeeList = () => { 

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const { profile } = useSelector((state) => state.auth);

  const message = useSelector((state) => state.message);

  const getModule = profile?.permissions?.find(va => va.moduleName === "Employee Management" || va.moduleName === "*")?.actions;

  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);

  const [searchTerm, setSearchTerm] = useState("");

  const { employees, totalCount } = useSelector((state)=> state.employee);

  const modifiedRows = employees ? employees?.map((va, index)=> ({sno:(index+1+((page-1)*rowsPerPage)), ...va, role: va?.role?.name})) : [] ;

  const handleSearch = (event) => {
    setSearchTerm(event.target.value);
  }

  const handleExport = () => {
    const ws = XLSX.utils.json_to_sheet(employees);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'employee.xlsx');
    
  };

  const handleEdit = (val) =>{
    
    navigate(`editemployee/${val._id}`, {
      state: { name: 'Edit' },
    });
  }

  const handleView = (val) =>{
    navigate(`employeedetails/${val._id}`);
    }

  const handleStatusChange = (row) => {
    const r_id = row._id;
    const formData = {
      status : !row.status
    }
    dispatch(updateEmployee({r_id, formData}))
    .then(()=>{
      dispatch(setLoading(false));
    })
    .catch((error)=>{
      dispatch(setLoading(false));
    })
  }

  useEffect(() => {
    if (message?.message) {
      toast(message.message)
      dispatch(clearMessage())
    }
  }, [message, dispatch])
  

  useEffect(()=>{
    const params = {
      page: page,
      limit: rowsPerPage,
      searchTerm: searchTerm 
    }
    if(getModule?.includes("employee_get") || getModule?.includes("*")){
    // dispatch(setLoading(true))
    dispatch(fetchEmployees(params))
    // .then(() => {
    //     dispatch(setLoading(false))
    //         })
    // .catch((error) => {
    //     dispatch(setLoading(false))
    //   })
    }
  }, [dispatch, getModule, page, rowsPerPage, searchTerm])

  return (
    <div className="content">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="h5" sx={{ mb: 3, mt: 3 }}>
          Employee List <Typography component="span">({totalCount})</Typography>
        </Typography>

        <Box
          sx={{
            display: "flex",
            alignItems: "center",
          }}
        >
            {(getModule?.includes("employee_get") || getModule?.includes("*")) &&
                    <>
          <TextField size="small" placeholder="Search by Employee Name" value={searchTerm} onChange={handleSearch} fullWidth />
          {/* <Button variant="contained" onClick={handleSearch}>
            search
          </Button> */}
          </>
                  }
          {(getModule?.includes("employee_create") || getModule?.includes("*")) &&
          <Link 
          to="addemployee"
          state= {{name: "Add"}} // Pass the data here
           >
          <Button variant="contained" startIcon={<PersonAddAlt1Icon />} sx={{ ml: 2, px: 3 }}>
            Add
          </Button>
          </Link>
          }
          <Button variant="contained" startIcon={<DownloadIcon />} onClick={handleExport} sx={{ ml: 2, px: 3 }}>
            Export
          </Button>
        </Box>
      </Box>
      {(getModule?.includes("employee_get") || getModule?.includes("*")) &&
      <CustomTable columns={columns} rows={ employees ? modifiedRows : [] } page={page} setPage={setPage} rowsPerPage={rowsPerPage} setRowsPerPage={setRowsPerPage} handleEdit={handleEdit} handleStatusChange={handleStatusChange} totalCount={totalCount} handleView={handleView}/>
      }
    </div>
  )
}

export default EmployeeList
